import trackCountChanges from '../helpers/trackCountChanges'
//----------------------
// process delete count
//----------------------
export default function processDeleteCount({
  count,
  character,
  changed_counts = [],
  original_counts = [],
}) {
  console.log('--------------------------------')
  console.log('IN processDeleteCount count = ', count)
  //-----------------------------------------
  // build new array excluding deletion count
  //-----------------------------------------
  const newCounts = character.counts.filter((s) => s.id !== count.id)
  //------------------
  // assign new array
  //------------------
  character.counts = newCounts
  //---------------------------------
  // track changes (record deletion)
  //---------------------------------
  const updated_changed_counts = trackCountChanges({
    count,
    original_counts: original_counts,
    changed_counts: changed_counts,
    delete: true, // used to remove entry from changed_counts where is new local count (not written to db yet)
  })
  console.log('updated_changed_counts after deletion:', updated_changed_counts)
  //---------
  // returns
  //---------
  return { character, updated_changed_counts }
}
